import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { CommonService } from '../Model/Common/common.service';
import { UserMasterService } from '../user-master.service';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { UserApplicabilityFilterComponent } from '../user-applicability-filter/user-applicability-filter.component';
import { ApprovalMatrixService } from '../Model/ApprovalMatrix/approval-matrix.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { SeparationModuleService } from '../separation-module.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../Util/Session/session.service';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { ComboService } from '../Model/Combo/combo.service';
import { ApprovalMatrixFormFilterComponent } from '../Setting/ApprovalMatrixFormFilter/approval-matrix-form-filter/approval-matrix-form-filter.component';

@Component({
  selector: 'app-separation-policy',
  standalone: true,
  imports: [CommonModule, NgbTooltipModule, FormsModule, NgSelectModule, LoaderComponent],
  templateUrl: './separation-policy.component.html',
  styleUrl: './separation-policy.component.scss'
})
export class SeparationPolicyComponent {

  isDisabled: boolean = false;

  constructor(
    protected tooltip: TooltipService,
    protected common: CommonService,
    // private userMasterService: UserMasterService,
    private modalService: NgbModal,
    private approvalMatrix: ApprovalMatrixService,
    private toast: ToastService,
    private separation: SeparationModuleService,
    private route: ActivatedRoute,
    private router: Router,
    private session: SessionService,
    private combo: ComboService,
  ) {
    // this.common.getPageRights();
    this.user = session.GetUserDetails();
    this.route.params.subscribe(params => this.SeparationRuleID = parseInt(params['id']));
  }

  ngOnInit() {
    if (this.SeparationRuleID > 0) {
      this.GetSeparationRule();
    } else {
      this.GetApplicability();
    }
  }

  allowBackdateSeparation: boolean = false;
  policybasedon = 'Month';
  user = {} as any;
  User: any;
  PolicyName = ''
  SeparationRuleID = 0;
  ProbationNoticePeriod = ''
  ConfirmedNoticePeriod = ''
  lastWorkingDayEditable = false;
  PastLWDLimitDays = '';
  FutureLWDLimitDays = '';
  BackDateSeparationDays = '';
  DefaultRule = false;
  LastWebESSApplicabilityId = null;

  SeparationRuleDetail = {
    SelectType: 'insert',
    ESS_SeparationRuleID: 0,
    SeparationRuleTitle: null,
    IsRegularizationForFutureDate: false,
    TillDateRequestForRegularization: null,
    AllowRegularizationForDays: null as any,
    AllowRegularizationFor: null,
    AllowRegularizationForSameDays: false,
    AllowRegulariationForPreviousMonth: false,
    DefaultRegularization: false,
    WebESSApplicabilityId: null as any,
    MappedId: null as any,
    EmpType: 'FRONT',
    AllowRequestAfterMonthlock: false,
  }

  Filter = {
    BranchID: null,
    ClientID: null,
    SiteID: null,
  }

  // Applicability Variables
  ApplicabilityDatasFilter = [] as any;
  ApplicabilityDatas = [] as any;
  Applicabilitys = [] as any;
  ApprovalSubCategory = [] as any;
  ApprovalSubCategoryFilter = [] as any;
  Companys = [] as any;
  CompanysFilter = [] as any;
  Departments = [] as any;
  DepartmentsFilter = [] as any;
  Users = [] as any;
  UsersFilter = [] as any;
  Branchs = [] as any;
  BranchsFilter = [] as any;
  Clients = [] as any;
  ClientsFilter = [] as any;
  Sites = [] as any;
  SitesFilter = [] as any;
  Designations = [] as any;
  DesignationsFilter = [] as any;
  Grades = [] as any;
  GradesFilter = [] as any;

  SaveSeparationPolicy() {
    if (this.SeparationRuleDetail.WebESSApplicabilityId == null) {
      this.toast.show({ message: 'Please select applicability', type: toastTypeEnum.warning });
      return;
    }
    else if (this.SeparationRuleDetail.WebESSApplicabilityId > 0 && this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck).length == 0) {
      this.toast.show({ message: 'Please select sub applicability', type: toastTypeEnum.warning });
      return;
    }

    this.SeparationRuleDetail.MappedId = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck && e.WebESSApplicabilityId == this.SeparationRuleDetail.WebESSApplicabilityId).map((e: any) => e.ApplicabilityDataID).toString()
    console.log(this.SeparationRuleDetail.MappedId);

    this.isDisabled = true;

    this.separation.SeparationRuleInsertUpdate({
      SelectType: this.SeparationRuleID == 0 || this.SeparationRuleID == null ? 'Insert' : 'Update',
      ESS_SeparationRuleId: this.SeparationRuleID,
      SeparationRuleName: this.PolicyName,
      DefaultRule: this.DefaultRule,
      EmpType: this.SeparationRuleDetail.EmpType,
      PolicyBasedOn: this.policybasedon,
      ProbationNoticePeriod: this.ProbationNoticePeriod,
      ConfirmedNoticePeriod: this.ConfirmedNoticePeriod,
      IsEmployeeLWDEditable: this.lastWorkingDayEditable,
      PastLWDLimitDays: this.PastLWDLimitDays,
      FutureLWDLimitDays: this.FutureLWDLimitDays,
      IsBackdateSeparationAllowed: this.allowBackdateSeparation,
      BackdateSeparationAllowedDays: this.BackDateSeparationDays,
      WebESSApplicabilityId: this.SeparationRuleDetail.WebESSApplicabilityId,
      MappedId: this.SeparationRuleDetail.MappedId,
      By: this.user.UserId,
    }).subscribe({
      next: (response) => {
        if (response.ErrorCode == "01") {
          this.toast.show({ message: response.ErrorMessage, type: toastTypeEnum.success });
          this.close();
        } else {
          this.toast.show({ message: response.ErrorMessage, type: toastTypeEnum.warning });
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (err) => {
        this.isDisabled = false;
      },
    })
  }

  GetSeparationRule() {
    this.isDisabled = true;
    this.separation.SeparationRuleLoad({
      SelectType: 1,
      ESS_SeparationRuleID: this.SeparationRuleID
    }).subscribe({
      next: (response) => {
        const data = response.Table[0];
        this.PolicyName = data['SeparationRuleName'];
        this.allowBackdateSeparation = data['IsBackdateSeparationAllowed'];
        this.lastWorkingDayEditable = data['IsEmployeeLWDEditable'];
        this.policybasedon = data['PolicyBasedOn'];
        this.BackDateSeparationDays = data['BackdateSeparationAllowedDays'];
        this.PastLWDLimitDays = data['PastLWDLimitDays'];
        this.FutureLWDLimitDays = data['FutureLWDLimitDays'];
        this.ProbationNoticePeriod = data['ProbationNoticePeriod'];
        this.ConfirmedNoticePeriod = data['ConfirmedNoticePeriod'];
        this.DefaultRule = data['DefaultRule'];
        // this.SeparationRuleDetail.EmpType = data['EmpType'];
        
        this.SeparationRuleDetail.MappedId = response.Table2.map((e: any) => e.MappedId).toString();
        this.SeparationRuleDetail.SelectType = 'Update';
        this.LastWebESSApplicabilityId = response.Table1[0]['WebESSApplicabilityId'];
        this.SeparationRuleDetail.WebESSApplicabilityId = response.Table1[0]['WebESSApplicabilityId'];
        
        if (this.SeparationRuleDetail.WebESSApplicabilityId == 1) {
          this.ApprovalComboLoad('Company');
        } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 2) {
          this.ApprovalComboLoad('Branch');
        } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 3) {
          //this.ApprovalComboLoad('Client');
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.SeparationRuleDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 4) {
          //this.ApprovalComboLoad('Site');
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.SeparationRuleDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 5) {
          this.ApprovalComboLoad('Department');
        } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 6) {
          this.ApprovalComboLoad('Designation');
        } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 7) {
          this.ApprovalComboLoad('User');
        } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 8) {
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.SeparationRuleDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 9) {
          this.ApprovalComboLoad('Grade');
        }
        if (this.SeparationRuleDetail.WebESSApplicabilityId == 8) {
          this.GetApplicability(false);
        } else {
          this.GetApplicability();
        }

        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (err) => {
        this.isDisabled = false;
      },
    })
  }

  Validate(form: any) {
    // if (form.valid) {
    this.SaveSeparationPolicy();
    // }
    // else {
    //   form.submitted = true;
    // }
  }

  close() {
    this.router.navigate(['/setting/separationpolicy/']);
  }

  SearchDropdown(SearchValue: string, Label: string) {
    if (Label == 'Applicability') {
      this.ApplicabilityDatasFilter = this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityData.toLowerCase().includes(SearchValue.toLowerCase()));
    }
  }

  ButtonApplicabilityDataFilter(id = 0) {
    if (
      (id == 3 || id == 4 || id == 8) ||
      (id == 0 && (this.SeparationRuleDetail.WebESSApplicabilityId == 3 || this.SeparationRuleDetail.WebESSApplicabilityId == 4 || this.SeparationRuleDetail.WebESSApplicabilityId == 8))) {
      this.ApplicabilityDataFilter(true);
    } else {
      this.toast.show({ message: "Filter only allow for client & site", type: toastTypeEnum.warning });
    }
  }

  async ApplicabilityDataFilter(IsFilter = false) {
    // if (this.SeparationRuleDetail.WebESSApplicabilityId != 8 || !IsFilter) {
    //   this.ApplicabilityDatas = [];
    //   this.ApplicabilityDatasFilter = [];
    // }
    if (IsFilter || await this.Confirmation(IsFilter)) {
      if (!IsFilter) {
        this.ApplicabilityDatas = [];
        this.ApplicabilityDatasFilter = [];
        this.SeparationRuleDetail.MappedId = null;
        this.LastWebESSApplicabilityId = this.SeparationRuleDetail.WebESSApplicabilityId;
      } else {
        this.ApplicabilityDatas = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck);
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
      }

      this.Filter.BranchID = null;
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
      if (this.SeparationRuleDetail.WebESSApplicabilityId == 1) {
        this.ApprovalComboLoad('Company');
      } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 5) {
        this.ApprovalComboLoad('Department');
      } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 6) {
        this.ApprovalComboLoad('Designation');
      } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 7) {
        this.ApprovalComboLoad('User');
      } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 9) {
        this.ApprovalComboLoad('Grade');
      } else {
        if (this.SeparationRuleDetail.WebESSApplicabilityId != 0) {
          this.FilterForm();
        }
      }
    }
  }

  ApprovalComboLoad(Combotype: String, Combotype2 = null as any, index = 0) {
    this.isDisabled = true;
    this.combo.ApprovalComboLoad({
      'SelectType': Combotype,
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Company') {
          this.Companys = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));
          this.CompanysFilter = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));

          this.Companys.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.CompanyMasterId,
                ApplicabilityData: element.CompanyName,
                WebESSApplicabilityId: this.SeparationRuleDetail.WebESSApplicabilityId,
                IsCheck: this.SeparationRuleDetail.MappedId != null ? this.SeparationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.CompanyMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Branch') {
          this.Branchs = response.Table;
          this.BranchsFilter = response.Table;

          this.Branchs.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.SeparationRuleDetail.WebESSApplicabilityId,
                IsCheck: this.SeparationRuleDetail.MappedId != null ? this.SeparationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Department') {
          this.Departments = response.Table;
          this.DepartmentsFilter = response.Table;

          this.Departments.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DepartmentMasterID,
                ApplicabilityData: element.DepartmentName,
                WebESSApplicabilityId: this.SeparationRuleDetail.WebESSApplicabilityId,
                IsCheck: this.SeparationRuleDetail.MappedId != null ? this.SeparationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.DepartmentMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.Table;
          this.DesignationsFilter = response.Table;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DesignationMasterID,
                ApplicabilityData: element.DesignationName,
                WebESSApplicabilityId: this.SeparationRuleDetail.WebESSApplicabilityId,
                IsCheck: this.SeparationRuleDetail.MappedId != null ? this.SeparationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.DesignationMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Client') {
          this.Clients = response.Table;
          this.ClientsFilter = response.Table;

          this.Clients.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.ClientGroupMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.ClientGroupMasterID,
                  ApplicabilityData: element.ClientGroupName,
                  WebESSApplicabilityId: this.SeparationRuleDetail.WebESSApplicabilityId,
                  IsCheck: this.SeparationRuleDetail.MappedId != null ? this.SeparationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.ClientGroupMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'Site') {
          this.Sites = response.Table;
          this.SitesFilter = response.Table;

          this.Sites.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteName,
                  WebESSApplicabilityId: this.SeparationRuleDetail.WebESSApplicabilityId,
                  IsCheck: this.SeparationRuleDetail.MappedId != null ? this.SeparationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.SiteMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.ComboLoad;
          this.DesignationsFilter = response.ComboLoad;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.SeparationRuleDetail.WebESSApplicabilityId,
                IsCheck: this.SeparationRuleDetail.MappedId != null ? this.SeparationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == null) {
          this.Users = response.Table;
          this.UsersFilter = response.Table;

          this.Users.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.UserMasterId,
                ApplicabilityData: element.UserName,
                WebESSApplicabilityId: this.SeparationRuleDetail.WebESSApplicabilityId,
                IsCheck: this.SeparationRuleDetail.MappedId != null ? this.SeparationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.UserMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == 'Employee') {
          response.Table.forEach((element: any) => {
            this.ApprovalSubCategory.push(
              {
                ApprovalSubCategoryID: element.UserMasterId,
                ApprovalSubCategory: element.UserName,
              }
            );
          });
          this.ApprovalSubCategoryFilter[index] = this.ApprovalSubCategory;
        } else if (Combotype == 'Grade') {
          this.Grades = response.Table;
          this.GradesFilter = response.Table;

          this.Grades.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.GradeMasterId,
                ApplicabilityData: element.GradeName,
                WebESSApplicabilityId: this.SeparationRuleDetail.WebESSApplicabilityId,
                IsCheck: this.SeparationRuleDetail.MappedId != null ? this.SeparationRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.GradeMasterId) >= 0 ? true : false : false,
              }
            );
          });
        }
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        this.SeparationRuleDetail.MappedId = null;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApplicabilityCheckAll(event: any) {
    this.ApplicabilityDatasFilter.map((e: any) => e.IsCheck = event.target.checked);
  }

  OrderByApplicability() {
    return this.ApplicabilityDatasFilter.sort((a: any, b: any) => a.ApplicabilityData.localeCompare(b.ApplicabilityData));
  }

  async Confirmation(IsFilter = false): Promise<boolean> {
    if (!IsFilter && this.LastWebESSApplicabilityId != null) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = this.tooltip.Message.ApplicabiliyChangeMessgae;
      modalRef.componentInstance.Message2 = this.tooltip.Message.ApplicabiliyChangeMessgae2;
      return modalRef.result.then((result) => {
        if (!result) {
          this.SeparationRuleDetail.WebESSApplicabilityId = this.LastWebESSApplicabilityId;
        }
        return result;
      });
    } else {
      return true;
    }
  }

  FilterForm() {
    const modalRef = this.modalService.open(ApprovalMatrixFormFilterComponent, { size: 'lg' });
    modalRef.componentInstance.Title = this.SeparationRuleDetail.WebESSApplicabilityId == 3 ? 'Client' : this.SeparationRuleDetail.WebESSApplicabilityId == 4 ? 'Site' : this.SeparationRuleDetail.WebESSApplicabilityId == 8 ? 'Employee' : '';
    modalRef.componentInstance.WebESSApplicabilityId = this.SeparationRuleDetail.WebESSApplicabilityId;
    modalRef.componentInstance.EmpType = this.SeparationRuleDetail.EmpType;
    modalRef.componentInstance.ShowFilter = {
      ShowBranch: (this.SeparationRuleDetail.WebESSApplicabilityId == 3 || this.SeparationRuleDetail.WebESSApplicabilityId == 4 || this.SeparationRuleDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowClient: (this.SeparationRuleDetail.WebESSApplicabilityId == 4 || this.SeparationRuleDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowSite: (this.SeparationRuleDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowSearchEmployee: (this.SeparationRuleDetail.WebESSApplicabilityId == 8 || this.SeparationRuleDetail.WebESSApplicabilityId == 4) ? true : false
    }
    modalRef.result.then(result => {
      this.Filter.BranchID = result.BranchID;
      this.Filter.ClientID = result.ClientID;
      this.Filter.SiteID = result.SiteID;
      if (this.SeparationRuleDetail.WebESSApplicabilityId == 1) {
        //this.ApprovalComboLoad('Company');
      } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 3) {
        this.ApprovalComboLoad('Client');
      } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 4) {
        if (result.length >= 0) {
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteCode + '-' + element.SiteName,
                  WebESSApplicabilityId: this.SeparationRuleDetail.WebESSApplicabilityId,
                  IsCheck: true,
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else {
          this.ApprovalComboLoad('Site');
        }
      } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 5) {
        //this.ComboLoad('Department');
      } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 6) {
        //this.ComboLoad('Designation');
      } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 7) {
        //this.ComboLoad('User');
      } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 8) {
        if (result != undefined) {
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.EmpMasterID,
                  ApplicabilityData: element.FullName,
                  WebESSApplicabilityId: this.SeparationRuleDetail.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        }
      }
    });
  }

  GetApplicability(IsClear = true) {
    this.isDisabled = true;
    this.approvalMatrix.GetApplicability({ SelectType: 'SR', WebESSApplicabilityMasterID: 0, EmpType: this.SeparationRuleDetail.EmpType }).subscribe({
      next: (response) => {
        this.Applicabilitys = response.Table;
        if (response.Table.findIndex((e: any) => e.WebESSApplicabilityMasterID == 0) >= 0) {
          this.Applicabilitys.push(response.Table.filter((e: any) => e.WebESSApplicabilityMasterID == 0)[0]);
          this.Applicabilitys.splice(this.Applicabilitys.findIndex((e: any) => e.WebESSApplicabilityMasterID == 0), 1);
        }
        if (this.Applicabilitys.filter((e: any) => e.WebESSApplicabilityMasterID == this.SeparationRuleDetail.WebESSApplicabilityId).length == 0) {
          this.SeparationRuleDetail.WebESSApplicabilityId = null;
          this.ApplicabilityDatasFilter = [];
        } else if (this.SeparationRuleDetail.WebESSApplicabilityId == 8 && IsClear) {
          this.ApplicabilityDatasFilter = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

}